import { PayloadAction } from "@reduxjs/toolkit";
import { ServiceState } from "../../models/ServiceState";
import { DeleteServicePayload } from "../../payload/DeleteService/DeleteServicePayload";

const deleteServiceFetch = (state: ServiceState, action: PayloadAction<DeleteServicePayload>) => {
    state.isLoading = false;
}

export default deleteServiceFetch;